// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detailsSeparateText-module_rightSection__Jyd_h {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;

    &.detailsSeparateText-module_rightSectionEnd__xEKJD {
        justify-content: flex-end;
    }
    &.detailsSeparateText-module_clickable__j1bNz {
        cursor: pointer;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/detailsSeparateText.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;;IAEX;QACI,yBAAyB;IAC7B;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".rightSection {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1 0 0;\n\n    &.rightSectionEnd {\n        justify-content: flex-end;\n    }\n    &.clickable {\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightSection": `detailsSeparateText-module_rightSection__Jyd_h`,
	"rightSectionEnd": `detailsSeparateText-module_rightSectionEnd__xEKJD`,
	"clickable": `detailsSeparateText-module_clickable__j1bNz`
};
export default ___CSS_LOADER_EXPORT___;
